export const CHANGE_STATE_CONTEXT_SHOULD_RENDER = 'CHANGE_STATE_CONTEXT_SHOULD_RENDER'; // eslint-disable-line
